import { render } from "./IngredientsList.vue?vue&type=template&id=00db5ffc&scoped=true"
import script from "./IngredientsList.vue?vue&type=script&lang=js"
export * from "./IngredientsList.vue?vue&type=script&lang=js"

import "./IngredientsList.vue?vue&type=style&index=0&id=00db5ffc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00db5ffc"]])

export default __exports__